/**
 * Shared timezone helpers for pickers.
 *
 * COMMON_TIMEZONES was born in LocationFormModal's combobox (the "Common"
 * group + the fallback when Intl.supportedValuesOf is unavailable); hoisted
 * here (BLU-734) so the Portless digest schedule's timezone Select offers the
 * same curated set instead of forking its own.
 */

/** Common operational timezones, in rough west→east display order. */
export const COMMON_TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Europe/London',
  'Europe/Paris',
  'Europe/Prague',
  'Europe/Berlin',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Asia/Dubai',
  'Australia/Sydney',
  'Australia/Melbourne',
];

/**
 * "GMT+8" / "GMT-4" for an IANA zone at the current instant (DST-aware).
 * Unknown zone → empty string (callers render the bare zone name).
 */
export function gmtOffsetLabel(timeZone: string): string {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'shortOffset',
    }).formatToParts(new Date());
    return parts.find((p) => p.type === 'timeZoneName')?.value ?? '';
  } catch {
    return '';
  }
}
